import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { Observable, throwError } from 'rxjs';
import { SERVER_URL } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class AuthService {


    public signedUser: any;
    public accessToken: any;
    public userId: any;
    public clientId: any;
    public employeeId: any;
    public firstName: any;
    public lastName: any;
    public APIKey: any;
    public userRole: any; 
    public refreshToken: any;
    public signature: any;
    public userLocationID: any = "";
 
    
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    constructor(
        private http: HttpClient,
        public storage: Storage
    ) {
      
    }

    login(email: any, password: any) : Observable<any> {
        // const url = SERVER_URL + '/api/register/log_in';
        // console.log(email);
        // let httpParams = new HttpParams()
        // .set("Username", email)
        // .set("Password", password);
        // return this.http.post(url, httpParams , this.httpOptions);

        // const url = SERVER_URL + '/api/register/log_in';
        // console.log('Login attempt with email:', email);
        
        // // ✅ FIX: Use URLSearchParams instead of HttpParams for better encoding control
        // const body = new URLSearchParams();
        // body.set('Username', email);
        // body.set('Password', password);
        
        // console.log('Encoded body string:', body.toString());
        
        // return this.http.post(url, body.toString(), this.httpOptions);
        const url = SERVER_URL + '/api/register/log_in';
        // ✅ FIX: Manually encode each parameter to ensure proper handling
        const encodedEmail = encodeURIComponent(email);
        const encodedPassword = encodeURIComponent(password);
        const body = `Username=${encodedEmail}&Password=${encodedPassword}`;

        return this.http.post(url, body, this.httpOptions);
    }



    logout(){
        
        this.storage.remove('auth');
        this.storage.clear();
        this.signedUser = ''
        this.accessToken = '';
        this.refreshToken = '';
    }

}
